import { SiteHeader } from '../../shared/components/SiteHeader';
import { SiteFooter } from '../../shared/components/SiteFooter';
import { PageHero } from '../../shared/components/PageHero';
import styles from './ServicesPage.module.css';
import heroImage from '../../../assets/services/hero.png';

type ServiceBlock = {
  readonly number: string;
  readonly title: string;
  readonly lead: readonly string[];
  readonly body: readonly string[];
  readonly cards: readonly (readonly string[])[];
};

const SERVICE_BLOCKS: readonly ServiceBlock[] = [
  {
    number: '1',
    title: 'IT事業',
    lead: ['「金融×テクノロジー」で、', 'ビジネスの未来を実装する。'],
    body: [
      '最先端のAI技術やFinTechを駆使したシステム開発・ソリューションを提供します。',
      '金融や保険といった高い専門性が求められる領域において、',
      '私たちの持つ業界知識と高度なIT技術をシームレスに融合（クロスドメイン）。',
      '法人のお客様の業務効率化や、AIを活用したデータ分析、次世代FinTechサービスの開発など、',
      '変化の激しいDX時代を勝ち抜くためのIT基盤を共に構築いたします。',
    ],
    cards: [
      ['金融・保険領域に特化した', 'FinTechシステムの開発・支援'],
      ['AI技術（チャットボット・データ解析等）を', '活用した業務自動化・効率化'],
      ['企業のデジタルトランスフォーメンション', '（DX）に関わるITコンサルティング'],
    ],
  },
  {
    number: '2',
    title: '資産運用事業',
    lead: ['確かなデータと知見で、', '豊かで安心できる未来を', 'デザインする。'],
    body: [
      '個人投資家のお客様を中心に、資産運用のアドバイスやライフプランに合わせた',
      '最適な金融・保険商品のご提案を行う独立系アドバイザー（IFA）の役割を担っています。',
      '私たちの最大の強みは、長年培った金融・投資のノウハウに、',
      '最新の「IT・データ分析力」を掛け合わせている点です。',
      '日本株を中心とした投資アドバイザリーから、富裕層向けの米国年金保険商品の紹介、',
      'さらには企業の持続的成長を支えるビジネスコンサルティングまで、',
      '客観的なデータに基づいた透明性の高い資産形成プランをご提案いたします。',
    ],
    cards: [
      ['日本株を中心とした', '金融投資アドバイザー業務（IFA）'],
      ['富裕層向け資産形成支援', 'およびコンサルティング'],
      ['自動売買支援サービス', '「Turtle Trader」'],
    ],
  },
];

export const ServicesPage = (): JSX.Element => {
  return (
    <div className={styles.page}>
      <SiteHeader variant="solid" />

      <PageHero image={heroImage} eyebrow="SERVICE" title="サービス紹介" />

      <section className={styles.intro}>
        <h2 className={styles.introTitle}>
          テクノロジーの力で、金融と保険の未来を革新する。
        </h2>
        <p className={styles.introText}>
          CJインベストメントは、最先端のIT・AI技術と、確かな資産運用の知見を掛け合わせた「融合（クロスドメイン）」のプロフェッショナル集団です。
          個人のお客様の確かな未来を築く資産運用から、法人のお客様のビジネスを加速させるFinTechソリューションまで。私たちが、次世代のスタンダードを実装します。
        </p>
      </section>

      {SERVICE_BLOCKS.map((block) => (
        <section key={block.number} className={styles.service}>
          <div className={styles.serviceInner}>
            <div className={styles.serviceHead}>
              <div>
                <p className={styles.eyebrow}>
                  <span className={styles.eyebrowText}>SERVICE</span>
                  <span className={styles.eyebrowNum}>{block.number}</span>
                </p>
                <h2 className={styles.serviceTitle}>{block.title}</h2>
                <p className={styles.serviceLead}>
                  {block.lead.map((line, index) => (
                    <span key={line}>
                      {index > 0 && <br />}
                      {line}
                    </span>
                  ))}
                </p>
              </div>
              <div className={styles.serviceBody}>
                {block.body.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </div>
            </div>

            <div className={styles.cards}>
              {block.cards.map((caption) => (
                <div key={caption.join('')} className={styles.card}>
                  <div className={styles.cardImage} aria-hidden />
                  <p className={styles.cardCaption}>
                    {caption.map((line, index) => (
                      <span key={line}>
                        {index > 0 && <br />}
                        {line}
                      </span>
                    ))}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <SiteFooter bordered />
    </div>
  );
};
